<template>
    <div id="newIntegrationSetup">
        <div class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form" @submit.prevent="saveIntegrationSetup">
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="description">{{ label.description }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="description" name="description" v-model="integration_setup.description" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="destination">{{ label.destination }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="text" class="form-control" id="destination" name="destination" v-model="integration_setup.destination" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="apiendpoint">{{ label.apiendpoint }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="text" class="form-control" id="apiendpoint" name="apiendpoint" v-model="integration_setup.apiendpoint" >
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="username">{{ label.username }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="text" class="form-control" id="username" name="username" v-model="integration_setup.username" >
                            </div>
                            <div class="col-sm-1">
                                <label class="control-label" for="apikey">{{ label.apikey }}</label>
                            </div>
                            <div class="col-sm-4">
                                <input type="text" class="form-control" id="apikey" name="apikey" v-model="integration_setup.apikey" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="port">{{ label.port }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="text" class="form-control" id="port" name="port" v-model="integration_setup.port" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="cutoffdate">{{ label.cutoffdate }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" id="cutoffdate" name="cutoffdate" v-model="integration_setup.cutoffdate" >
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="remark">{{ label.remark }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="remark" name="remark" v-model="integration_setup.remark" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="disable">{{ label.disable}}</label>
                            </div>
                            <div class="col-sm-8">
                                <input
                                    type="checkbox"
                                    id="disable"
                                    v-model="integration_setup.disable"
                                    true-value="1"
                                    false-value="0"
                                >
                            </div>
                        </div>
                        <div class="form-group row text-center">
                            <div class="col-sm-11">                        
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/integrationsetup`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
          title: 'NEW INTEGRATION SETUP',
          label: {
                description: 'DESCRIPTION',
                destination: 'DESTINATION',
                apiendpoint: 'API ENDPOINT',
                username: 'USERNAME',
                apikey: 'API KEY',
                port: 'API PORT',
                cutoffdate: 'CUTOFF DATE',
                remark: 'REMARK',
                disable: 'DISABLE'
            },
            integration_setup: {
                description: null,
                destination: null,
                apiendpoint: null,
                username: null,
                apikey: null,
                port: null,
                cutoffdate: null,
                remark: null,
                disable: '0'
            },
            validationMsg: '',
            status: '',
        
        }
    },

    methods: {
        saveIntegrationSetup() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/integrationsetup'

            axios.post(this.$store.getters.rootAPI + '/integrationsetup/create', {
                description: vm.integration_setup.description,
                destination: vm.integration_setup.destination,
                apiendpoint: vm.integration_setup.apiendpoint,
                username: vm.integration_setup.username,
                apikey: vm.integration_setup.apikey,
                port: vm.integration_setup.port,
                cutoffdate: vm.integration_setup.cutoffdate,
                remark: vm.integration_setup.remark,
                disable: vm.integration_setup.disable
            })
            .then(function (response) {  
                vm.status = response.data.status
                
                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }              
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/integrationsetup/NewIntegrationSetup.vue